import { useState } from "react";
import { ArrowLeft, KeyRound, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";
import { api, errMsg } from "@/lib/api";

export const MotDePasseOublie = ({ emailInitial, onRetour }) => {
  const [etape, setEtape] = useState("email");
  const [f, setF] = useState({ email: emailInitial || "", code: "", nouveau: "", confirmation: "" });
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const envoyer = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { const { data } = await api.post("/auth/forgot-password", { email: f.email }); setMsg(data.message); setEtape("code"); }
    catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };
  const reinitialiser = async (e) => {
    e.preventDefault();
    if (f.nouveau !== f.confirmation) { setError("Les deux mots de passe ne correspondent pas"); return; }
    setError(""); setLoading(true);
    try { await api.post("/auth/reset-password", { email: f.email, code: f.code.trim(), nouveau: f.nouveau }); onRetour("Mot de passe modifié : connectez-vous avec le nouveau."); }
    catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <form onSubmit={etape === "email" ? envoyer : reinitialiser} className="px-7 pt-8 pb-6" data-testid="reset-form">
      <KeyRound className="h-7 w-7 text-emerald-700" />
      <h2 className="mt-4 text-2xl font-bold tracking-tight">Mot de passe oublié</h2>
      <p className="mt-1 text-sm text-slate-500">{etape === "email" ? "Recevez un code à 6 chiffres par courriel." : msg}</p>
      <div className="mt-6 space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="reset-email">Email</Label>
          <Input id="reset-email" type="email" required value={f.email} onChange={set("email")} disabled={etape === "code"} data-testid="reset-email-input" />
        </div>
        {etape === "code" && <>
          <div className="space-y-1.5">
            <Label htmlFor="reset-code">Code reçu (valable 15 min)</Label>
            <Input id="reset-code" required inputMode="numeric" maxLength={6} pattern="\d{6}" value={f.code} onChange={set("code")} className="font-mono tracking-[0.4em] text-center" data-testid="reset-code-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="reset-nouveau">Nouveau mot de passe</Label>
            <PasswordInput id="reset-nouveau" required minLength={10} autoComplete="new-password" value={f.nouveau} onChange={set("nouveau")} testId="reset-nouveau-input" />
            <p className="text-[11px] text-slate-500">10 caractères minimum, au moins une lettre et un chiffre.</p>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="reset-confirmation">Confirmer</Label>
            <PasswordInput id="reset-confirmation" required minLength={10} autoComplete="new-password" value={f.confirmation} onChange={set("confirmation")} testId="reset-confirmation-input" />
          </div>
        </>}
        {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full bg-emerald-700 hover:bg-emerald-800" data-testid="reset-submit-button">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{etape === "email" ? "Recevoir le code" : "Changer le mot de passe"}
        </Button>
        {etape === "code" && <button type="button" onClick={() => { setEtape("email"); setMsg(""); }} className="w-full text-xs text-slate-500 hover:text-emerald-700" data-testid="reset-renvoyer">Renvoyer un code</button>}
      </div>
      <button type="button" onClick={() => onRetour("")} className="mt-6 inline-flex items-center gap-1 text-xs text-slate-500 hover:text-emerald-700" data-testid="reset-retour">
        <ArrowLeft className="h-3.5 w-3.5" />Retour à la connexion
      </button>
    </form>
  );
};
